import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import AudioPlayer from "react-custom-audio-player";
import MultimediaItem from "../../Elements/MultimediaItem/MultimediaItem";
import RightIconMenu from "../RightIconMenu";

// import BasicSoundPlayer  from '../../Elements/AWSSoundPlayer';
export default class View_type_15 extends Component {
	constructor(props) {
		super(props);
		//console.log("View_type_15 ", props);
		var data = Array.isArray(props.data) ? props.data[0] : props.data;
		this.state = {
			data: data,
			r_menu: data.right_menu ? data.right_menu : [],
			r_menu_serach: data.right_menu_serach ? data.right_menu_serach : [],
			title: data.title ? data.title : "",
			tabs: data.tabs ? props.data.tabs : [],
			content: data.content ? data.content : [],
			read_more: data.read_more ? data.read_more : [],
			list: data.list ? data.list : [],
			content_title: data.content_title ? data.content_title : null,
			single_audio: data.single_audio ? data.single_audio : null,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		// console.log('ADUO',this.state.audio);
	}

	createMarkup(item) {
		return { __html: item };
	}

	inputHandler = e => {
		//console.log(e.target.value);
	};

	render() {
		//console.log("multimedia test", this.props.data.multimedia);
		const {
			description,
			title_image,
			table,
			title_description
		} = this.props.data;
		var _this = this;
		var var1 = this.state.data.title ? this.state.data.title : "";

		var calendar = this.state.calendar ? (
			<Link to={this.state.calendar.url}>
				<div className="vt2-calendar">
					<img className="vt2-calendar-img" src={this.state.calendar.img} />
					{this.state.calendar.text}
				</div>
			</Link>
		) : null;

		return (
			<div className="vt2">
				<div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
					<div className="vt2 row">
						<div className="vt2-title">
							<div
								className="vt2-title-name vt14-title-name artists-pageTitle"
								dangerouslySetInnerHTML={{ __html: var1 }}
							/>
							{title_image && (
								<div className="vt14 title_image">
									{this.props.data.title_description && (
										<h2
											className="vt14 title-image__description title-image__description--bottom"
											dangerouslySetInnerHTML={_this.createMarkup(
												this.props.data.title_description
											)}
										/>
									)}
									<img src={title_image} />
								</div>
							)}
							{this.props.data.schedule && (
								<div className="vt14 schedule">
									{!this.props.data.starting_page ? (
										<div
											className=""
											dangerouslySetInnerHTML={_this.createMarkup(description)}
										/>
									) : (
										<div
											className="vt2_chopin_list__description"
											dangerouslySetInnerHTML={_this.createMarkup(description)}
										/>
									)}

									{this.props.data.schedule.map((elem, key) => {
										return (
											<div className="row vt14 schedule__wrapper" key={key}>
												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Gatunek:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.genre}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Tonacja:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.mood}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Opus:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.opus}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Data Powstania:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.date_start}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Wg Paderewskiego:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.wg_paderewskiego}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Wg Turlo:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.wg_turbo}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Obsada:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.cast}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Utwór dedytkowany:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.dedicated}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Zródla rękopismienne:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.sources &&
														<div>
															{elem.sources.length > 1 ? (
																<div>
																	{elem.sources.map(elem1 => {
																		return (
																			<div

																				dangerouslySetInnerHTML={_this.createMarkup(elem1.list)}
																			/>

																		)

																	})}
																</div>
															) : (
																<span>{elem.sources}</span>
															)}
														</div>

													}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Pierwodruki:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right schedule__border--pierwodruki">
													{" "}

													{elem.editions &&
														<div>
															{elem.editions.length > 1 ? (
																<div>
																	{elem.editions.map((elem1, index) => {
																		return (
																			<span
																				key={index}
																				style={{
																					display: "block"
																				}}
																			>
																				{elem1.list}
																			</span>
																		);
																	})}
																</div>
															) : (
																<span
																	style={{
																		display: "block"
																	}}
																>
																	{elem.list}
																</span>
															)}
														</div>
													}
												</div>
											</div>
										);
									})}
								</div>
							)}
							{table && (
								<div className="row vt14 table-container">
									{table.map((elem, key) => {
										return (
											<div key={key} className="col-sm-4 vt14 table-row">
												{elem.name_multi}
												<hr />
											</div>
										);
									})}
								</div>
							)}
							<h2 className="vt14-content__title">
								{this.state.content_title}
							</h2>
							{!this.state.data.schedule && (
								<div
									className=""
									style={{
										marginBottom: "25px"
									}}
									dangerouslySetInnerHTML={_this.createMarkup(description)}
								/>
							)}

							<div className="vt2-title-tabs">
								{this.state.tabs.map(function(object, i) {
									if (object.active === 1) {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<div className="vt2 tab-checked">
													<Link to={"/" + object.link}>{object.title}</Link>
												</div>
											</div>
										);
									} else {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<Link to={"/" + object.link}>{object.title}</Link>
											</div>
										);
									}
								})}
							</div>
						</div>
						<div className="vt2-content">
							<div
								dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
							/>
						</div>
						<div>
							{!this.props.data.content ? (
								<div>
									{" "}
									{this.state.data.list.map(function(object, i) {
										//console.log("tlo", object.img);
										if (object.cols == 3) {
											var color = "rgba(0,156,178,0.5)";

											if (
												object !== "undefined" &&
												object.hasOwnProperty("img") &&
												!object.hasOwnProperty("text")
											) {
												var img = object.img;
												var thumbnail = (
													<div
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white",
															position: "absolute",
															left: 15,
															right: 15
														}}
													>
														{object.title}
													</div>
												);
												return (
													<div
														className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
														key={i}
													>
														<div>
															{thumbnail}
															<img src={img} className="vt2 list_image" />
														</div>
													</div>
												);
											} else if (object !== "undefined") {
												var button = null;
												var img = object.img;
												var thumbnail = (
													<div
														className="vt2 middle-thumbnailholder"
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white"
														}}
													>
														{object.title}
													</div>
												);
												var img = (
													<div>
														<img src={img} />
													</div>
												);

												if (typeof object.button !== "undefined") {
													button = (
														<div className="vt2 middle-addelem">
															<Link
																to={object.button.link}
																className="vt2 more_button"
															>
																{" "}
															</Link>
														</div>
													);
												}

												if (i == 0) {
													return (
														<div
															className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
															key={i}
														>
															<div className="vt2 row">
																<div
																	className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
																	// style={{
																	// 	backgroundImage: `url(${object.img})`,
																	// 	height: "150px"
																	// }}
																>
																	{img}
																	{/* <p>

																							{object.audio}
																						</p> */}
																</div>
																<div>
																	<Link to={object.button.link}>
																		<div
																			className="ChopinLists__text-button"
																			dangerouslySetInnerHTML={_this.createMarkup(
																				object.text
																			)}
																		/>
																	</Link>
																	{/* {button} */}
																	{/* {object.audio && (
																		<span className="audio__wrapper">
																			<AudioPlayer
																				src="http://dev.seraaq.com/nifc_nowa_strona/api_chopin/assets/audio.mp3"
																				controls={true}
																			/>
																		</span>
																	)} */}
																	<div
																		className="ChopinLists__sub-title"
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.sub_title
																		)}
																	/>
																</div>
															</div>
														</div>
													);
												} else {
													return (
														<div
															className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
															key={i}
														>
															<div className="vt2 row">
																<div
																	className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
																	// style={{
																	// 	height: "150px",
																	// 	background: `url(${object.img})`
																	// }}
																>
																	{img}
																</div>
																<div>
																	<Link to={object.button.link}>
																		<div
																			className="ChopinLists__text-button"
																			dangerouslySetInnerHTML={_this.createMarkup(
																				object.text
																			)}
																		/>
																	</Link>
																	{/* {button} */}
																	{/* {object.audio && (
																		<span className="audio__wrapper">
																			<AudioPlayer
																				src="http://dev.seraaq.com/nifc_nowa_strona/api_chopin/assets/audio.mp3"
																				controls={true}
																			/>
																		</span>
																	)} */}
																	<div
																		className="ChopinLists__sub-title"
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.sub_title
																		)}
																	/>
																</div>
															</div>
														</div>
													);
												}
											}
										} else {
											var color = "rgba(0,156,178,0.5)";

											if (
												object !== "undefined" &&
												object.hasOwnProperty("img") &&
												!object.hasOwnProperty("text")
											) {
												var img = object.img;
												var thumbnail = (
													<div
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white",
															position: "absolute",
															left: 15,
															right: 15
														}}
													>
														{object.title}
													</div>
												);
												return (
													<div
														className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
														key={i}
													>
														<div>
															{thumbnail}
															<img src={img} className="vt2 list_image" />
														</div>
													</div>
												);
											} else if (object !== "undefined") {
												var button = null;
												var img = object.img;
												var thumbnail = (
													<div
														className="vt2 middle-thumbnailholder"
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white"
														}}
													>
														{object.title}
													</div>
												);
												var img = (
													<div>
														<img src={img} />
													</div>
												);

												if (typeof object.button !== "undefined") {
													button = (
														<div className="vt2 middle-addelem">
															<Link
																to={object.button.link}
																className="vt2 more_button"
															>
																{" "}
															</Link>
														</div>
													);
												}

												if (i == 0) {
													return (
														<div
															className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
															key={i}
														>
															<div className="vt2 middle-postblock">
																{img}
																<div
																	dangerouslySetInnerHTML={_this.createMarkup(
																		object.text
																	)}
																/>
																{button}
															</div>
														</div>
													);
												} else {
													return (
														<div
															className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
															key={i}
														>
															<div className="vt2 middle-postblock">
																{img}
																<div
																	dangerouslySetInnerHTML={_this.createMarkup(
																		object.text
																	)}
																/>
																{button}
															</div>
														</div>
													);
												}
											}
										}
									})}
								</div>
							) : null}
						</div>
					</div>
					{this.props.data.multimedia &&
						<div className="vt15 multimedia__wrapper">
							<MultimediaItem {...this.props} />
						</div>
					 }

				</div>
				<div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{this.state.r_menu.length > 2 ? (
						<div className="vt2 RightMenu">
							<ul className="vt2 right_menu_items">
								{this.state.r_menu.map(function(object, i) {
									var var4 = object.url ? object.url : "";
									var var5 = object.name ? object.name : "";
									//console.log("RightMenu", object);
									return (
										<li className="vt2 left-menuItem" key={i}>
											<Link className="vt2 left-menuUnit" to={"/" + var4}>
												{var5}
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					) : (
						<div className="vt2 RightMenu vt14 RightMenu">
							{this.props.data.right_menu_serach_option && (
								<div>
									{" "}
									<span className="vt14 RightMenu__serach-title">
										szukaj wg:
									</span>
									<label className="vt14 RightMenu__serach-label">
										<p>Tytuł</p>
										<input
											className="vt14 RightMenu__serach-input"
											type="text"
										/>
									</label>
									<ul className="vt2 right_menu_items RightMenu list">
										{this.state.r_menu_serach.map(function(object, i) {
											var var4 = object.url ? object.url : "";
											var var5 = object.name ? object.name : "";
											//console.log("RightMenu", object);
											return (
												<li className="vt2 RightMenu item" key={i}>
													<Link to={"/" + var4}>{var5}</Link>
												</li>
											);
										})}
									</ul>
								</div>
							)}

							{this.state.single_audio && this.state.single_audio[0].src &&
								this.state.single_audio.map((elem, key) => {
									return (
										<div>
											<span className="audio__wrapper audio__wrapper--single">
												<p className="single_audio-listen">{elem.listen}:</p>
												<p className="single_adudio-name">
													<b>{elem.text}</b>
												</p>
												<AudioPlayer src={elem.src} controls={true} />
											</span>

											<div
												className="ChopinLists__sub-title"
												dangerouslySetInnerHTML={_this.createMarkup(
													elem.sub_title
												)}
											/>
										</div>
									);
								})}
						</div>
					)}
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_15/index.js